import React, { useEffect } from 'react'
import { setTabTitle } from '../../utils'
import { SearchConfigProvider } from './SearchConfigContext'
import { SearchConfigView } from './SearchConfigView'

export const SearchConfigContainer = () => {
    useEffect(() => {
        setTabTitle('Search Config')
    }, [])
    return (
        <SearchConfigProvider context={{}}>
            <SearchConfigView />
        </SearchConfigProvider>
    )
}
